// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_6eb00b8e53--checkbox--1snqs","label":"_6eb00b8e53--label--2iFBq","box":"_6eb00b8e53--box--GySjD","hasLabel":"_6eb00b8e53--hasLabel--3mmA3"};